import { render } from "./MessagesAdmin.vue?vue&type=template&id=47290453"
import script from "./MessagesAdmin.vue?vue&type=script&lang=js"
export * from "./MessagesAdmin.vue?vue&type=script&lang=js"
script.render = render

export default script